export enum TaskFrequency {
  OneTime = 'One Time',
  Weekday = 'Weekday',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
}

export enum TaskLogStatus {
  Complete = 'complete',
  Missed = 'missed',
  Skipped = 'skipped',
}
